import React, { PropTypes } from "react";
import { ControlLabel, FormGroup, HelpBlock } from "react-bootstrap";
import { FormattedMessage, intlShape } from "react-intl";
import classNames from "classnames";

const RadioGroup = (props, context) => {
  const {
    input,
    label,
    meta: { touched, error },
    radios,
    groupClassName,
    onChange,
    id,
    disabled,
    required,
  } = props;
  const validationState = touched && !!error ? error.state : null;
  const validationMessageKey =
    !!error && error.messageKey ? error.messageKey : null;
  const validationValues = !!error && error.values ? error.values : null;
  const scene = context.scene ? "-" + context.scene : "";
  const formattedRadios = radios.map((radio) => {
    const text = radio.text || context.intl.formatMessage({ id: radio.key });
    return { value: radio.value, text };
  });
  const radioLabelClassNames = classNames({
    disabled: disabled,
  });


  return (
    <FormGroup
      className={groupClassName}
      controlId={id + scene}
      validationState={validationState}
    >
      {label && (
        <ControlLabel>
          {label} {required ? <span className="required"> *</span> : ""}
        </ControlLabel>
      )}
      <div className="input-wrapper">
        {formattedRadios.map((radio,index)=>{ 
          return ( 
            <label  key={index} className={radioLabelClassNames}>
              <input
              {...input}
              disabled={disabled}
              key={index}
              type="radio"
              name={input.name}
              id={input.name + index}
              value={radio.value}
              checked={input.value != "" && input.value ==radio.value}
              onChange={(e)=>{
                onChange && onChange(e);
                return input.onChange(e);
              }}
              />
                <span className="radio-styler"/>
                <span className="radio-text">{radio.text}</span>
                </label>
              );
              })}
        {touched && error && (
          <HelpBlock>
            <FormattedMessage
              id={validationMessageKey}
              values={validationValues}
            />
          </HelpBlock>
        )}
      </div>
    </FormGroup>
  );
};

RadioGroup.propTypes = {
  disabled: PropTypes.bool,
  externalRoleIds:PropTypes.array,
  groupClassName: PropTypes.string,
  id: PropTypes.string,
  input: PropTypes.object.isRequired,
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onChange: PropTypes.func,
  meta: PropTypes.object.isRequired,
  radios: PropTypes.array.isRequired,
  required: PropTypes.bool,
  validation: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

RadioGroup.contextTypes = {
  intl: intlShape,
};

export default RadioGroup;



// WEBPACK FOOTER //
// ./src/components/common/form/RadioGroup.js